import { SET_HASHTAGS, ADD_HASHTAG, REMOVE_HASHTAG, CLEAR_HASHTAGS } from '../actions/actionTypes';

const preState = {
	hashtags: [],
};

const hashtagsReducer = (state = preState, action) => {
	const { type, hashtags, hashtag, id } = action;

	switch (type) {
		case SET_HASHTAGS:
			return { ...state, hashtags: [...hashtags] };
		case ADD_HASHTAG:
			return { ...state, hashtags: [...state.hashtags, hashtag] };
		case REMOVE_HASHTAG:
			return { ...state, hashtags: state.hashtags.filter(h => h.id !== id) };
		case CLEAR_HASHTAGS:
			return { ...preState };
		default:
			return state;
	}
};

export default hashtagsReducer;
